// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FAQCard_wrapper__39ou4","content":"FAQCard_content__1n1sm","button":"FAQCard_button__1slJf","open":"FAQCard_open__zMf2a"};